import * as React from 'react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { Grid, Row, Col } from "react-bootstrap";
import { StatsCard } from "components/StatsCard/StatsCard.jsx";
import { getServerStatus, getRegionNames } from '../components/Requests/Requests';
import moment from "moment";
import "moment-timezone";

export default class Services extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showMore: false,
            regionData: null,
            message: "",
            expectedRegions: [],
            loading: true
        }
        this.loadInner = this.loadInner.bind(this);
    }

    componentWillMount = () => {
        this.fetchServerStats(this.props.accessToken);
        this.getRegionNames();
        let tz = moment.tz.guess();
        moment.tz.setDefault(tz);
    }

    async getRegionNames() {
        let response = await getRegionNames(this.props.accessToken);
        if (response.status === 200) {
            let data = await response.json();
            this.setState({
                expectedRegions: data
            }, () => {
                // After both API calls, merge the data
                if (this.state.regionData) {
                    this.mergeExpectedRegions();
                }
            });
        }
    }

    //API Get Server Status
    fetchServerStats = (token) => {
        getServerStatus(token).then((response) => {
            if (response.status === 200) {
                response.json().then((data) => {
                    this.setState({ regionData: data }, () => {
                        // After both API calls, merge the data
                        if (this.state.expectedRegions.length > 0) {
                            this.mergeExpectedRegions();
                        }
                    });
                });
            }
            else if (response.status === 404) {
                this.setState({message: response.message, loading: false})
            }
            else {
                console.log(response.status);
                this.setState({loading: false});
            }
        });
    }

    mergeExpectedRegions = () => {
        const { regionData, expectedRegions } = this.state;
        
        // Get list of region names from the server status response
        const actualRegionNames = regionData.map(r => r.name);
        
        // Find regions that should exist but aren't in the response
        const missingRegions = expectedRegions.filter(
            expectedName => !actualRegionNames.includes(expectedName)
        );

        const missingRegionObjects = missingRegions.map(regionName => ({
            name: regionName,
            webRAG: 0, 
            success: 0,
            failure: 0,
            lastSuccessfulProvisionTime: null,
            servers: [],
            isMissing: true 
        }));
        
        const enrichedRegionData = [...regionData, ...missingRegionObjects];
        
        this.setState({ 
            regionData: enrichedRegionData,
            loading: false 
        });
    }

    calculateMins(time) {
        if (moment(time).year() < 1999) {
            return "Never"
        } else {
            let now = moment.utc();
            let nowIso = now.format("YYYY-MM-DDTHH:mm:ss");
            time = moment(time).format("YYYY-MM-DDTHH:mm:ss");
            return moment(time).from(nowIso);
        }
    }

    updateServerToggle = (enabled, regionName, server, index) => {

        let regionDataCopy = [...this.state.regionData];
        for (let region of regionDataCopy) {
            if (region.name !== regionName || region.servers.length <= 0) continue;
            if (region.servers[index].serverName === server.name) {
                region.servers[index].enabled = enabled //mutating the state so it updates the props in child component
            }
        }
        this.setState({ regionData: regionDataCopy })
    }

    getRAGIcon = (webRAG) => {
        // Red=0, Amber=1, Green=2
        if (webRAG === 0) {
            return <i className="fa fa-flag text-danger" title="WebRAG - Red" />
        }
        else if (webRAG === 2) {
            return <i className="fa fa-flag text-success" title="WebRAG - Green" />
        }

        return <i className="fa fa-flag text-warning" title="WebRAG - Amber" />
    }

    compareRegions = (a, b) => {
        return b.servers.length - a.servers.length;
    }

    compareServers = (a, b) => {
        // sort servers by server name; app pool name is the last token in the string, so split and reverse
        // the server name before comparing, this will ensure servers are sorted by app pool
        return (a.serverName.split('-').reverse().join('-')).localeCompare(b.serverName.split('-').reverse().join('-'))
    }

    loadInner() {
        if (this.state.loading) {
            return (
                <div className="card-inner-box loading">
                    <Spinner size={SpinnerSize.large} label="Fetching Server Data.." ariaLive="assertive" />
                </div>
            );
        }
        
        if (this.state.regionData) {
            return this.state.regionData.sort(this.compareRegions).map((region, index) => {
                const isMissing = region.isMissing || false;
                
                return (<div key={index}>
                    <Col xs={12}>
                        <StatsCard
                            bigIcon={null}
                            statsText={
                                <span>
                                    <span className="ms-font-xxl">{region.name}</span> 
                                    {isMissing ? (
                                        <i className="fa fa-exclamation-triangle text-danger" title="Region Not Found in Database" />
                                    ) : (
                                        this.getRAGIcon(region.webRAG)
                                    )}
                                </span>
                            }
                            statsValue={
                                isMissing ? (
                                    <span className="ms-font-xl text-danger">
                                        <b>No servers found in this region.</b>
                                    </span>
                            ) : (
                                <span className="ms-font-xl">
                                    Successes: <b>{region.success}</b> Failures: <b>{region.failure}</b>
                                </span>
                            )
                            }
                            statsIcon={<i className="fa fa-refresh" />}
                            statsIconText={
                                isMissing ? (
                                    <span className="ms-font-xl">
                                        Last Contacted: <b>Never</b>
                                    </span>
                                ) : (
                                    <span className="ms-font-xl">
                                        Last Contacted: <b>{this.calculateMins(region.lastSuccessfulProvisionTime)}</b>
                                    </span>
                                )
                            }
                            serverActions={null}
                            accessToken={this.props.accessToken}
                            serverName={null}
                            enabled={!isMissing}
                            index={null}
                            server={null}
                        />
                    </Col>
                    <div className="clearfix visible-xs-block"></div>
                    {
                        !isMissing && (
                            region.servers.sort(this.compareServers).map((server, index) => {
                                return (
                                    <Col lg={3} md={4} sm={6} key={index}>
                                        <StatsCard
                                            serverActions={server}
                                            accessToken={this.props.accessToken}
                                            regionName={region.name}
                                            serverName={server.name}
                                            enabled={server.enabled}
                                            index={index}
                                            server={server}
                                            updateServerToggle={this.updateServerToggle}
                                            flex
                                            bigIcon={<i className={region.webRAG === 2 ? "fa fa-check-circle-o text-success" : "fa fa-wrench text-warning"} />}
                                            statsText={<span className="ms-font-m"><b>{server.name}</b></span>}
                                            statsValue={<span className="ms-font-m">In Progress: <b>{server.inProgress}</b></span>}
                                            statsNote={<span className="ms-font-s"><nobr>Last Job: <b>{server.mostRecentJobStarted ? this.calculateMins(server.mostRecentJobStarted) : 'N/A'}</b></nobr></span>}
                                            statsIcon={<i className="fa fa-refresh" />}
                                            statsIconText={<span className="ms-font-m">Last Contacted: <b>{this.calculateMins(server.lastContact)}</b><br />Enabled: <b>{server.enabled.toString()}</b></span>}
                                        ></StatsCard>
                                    </Col>
                                );
                            })
                        )
                    }
                </div>)
            });
        } 
        
        return null;
    }

    render() {
        return (
            <div style={{ marginTop: '20px' }}>
                <Grid fluid><Row>{this.loadInner()}</Row></Grid>
            </div>
        )
    }
}
